import { FormControl } from '@angular/forms';
import { isWhitheSpaces } from '@commons/utility/util';

export function noWhitespaceValidator(control: FormControl) {
  const isWhitespace = isWhitheSpaces(control.value);
  const isValid = !isWhitespace;
  return isValid ? null : { whitespace: true };
}
